import { Directive, HostListener } from '@angular/core';
import { environment } from '../../../environments/environment';

@Directive({
  selector: '[hideMenu]',
  standalone: true
})
export class HideMenuDirective {

  constructor() {
  }

  @HostListener('click', ['$event.target'])
  public onClick(): void {
    if (environment.localEnv) {
      setTimeout(() => {
        document.body.classList.remove('js-show-gov-menu');
      });
    }
  }

}
